import { Link } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'

export interface IProps {
  link: Link
}

const removeExternals = ({ link }: IProps) => link && !link?.external

export { removeExternals }
